import React, {Component} from "react";


class OutputText extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className = "coreBlockItem-label" style={JSON.parse(this.props.blockItem.inputCss)} >
                <span>{this.props.blockItem.label}</span>
            </div>
        );
    }
}

export default OutputText;